import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconRatio$1 = /*@__PURE__*/ proxyCustomElement(class WppIconRatio extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-ratio", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M7.20006 7.4001C7.20006 7.17882 7.07827 6.97551 6.88318 6.87109C6.68808 6.76668 6.45136 6.77813 6.26724 6.90087L5.06724 7.70087C4.79153 7.88468 4.71702 8.2572 4.90083 8.53292C5.08465 8.80864 5.45717 8.88314 5.73288 8.69933L6.00006 8.52121V12.6001C6.00006 12.9315 6.26869 13.2001 6.60006 13.2001C6.93143 13.2001 7.20006 12.9315 7.20006 12.6001V7.4001ZM14.4 7.40014C14.4 7.17886 14.2782 6.97554 14.0831 6.87113C13.888 6.76672 13.6513 6.77816 13.4672 6.90091L12.2672 7.70091C11.9915 7.88472 11.917 8.25724 12.1008 8.53296C12.2846 8.80867 12.6571 8.88318 12.9328 8.69937L13.2 8.52125V12.6001C13.2 12.9315 13.4686 13.2001 13.8 13.2001C14.1314 13.2001 14.4 12.9315 14.4 12.6001V7.40014ZM10.8001 11.6001C10.8001 12.0419 10.4419 12.4001 10.0001 12.4001C9.55824 12.4001 9.20006 12.0419 9.20006 11.6001C9.20006 11.1583 9.55824 10.8001 10.0001 10.8001C10.4419 10.8001 10.8001 11.1583 10.8001 11.6001ZM10.0001 9.2001C10.4419 9.2001 10.8001 8.84193 10.8001 8.4001C10.8001 7.95827 10.4419 7.6001 10.0001 7.6001C9.55824 7.6001 9.20006 7.95827 9.20006 8.4001C9.20006 8.84193 9.55824 9.2001 10.0001 9.2001ZM4.6 3.6001C3.16406 3.6001 2 4.76416 2 6.2001V13.8001C2 15.236 3.16406 16.4001 4.6 16.4001H15.4C16.8359 16.4001 18 15.236 18 13.8001V6.2001C18 4.76416 16.8359 3.6001 15.4 3.6001H4.6ZM3.2 6.2001C3.2 5.4269 3.8268 4.8001 4.6 4.8001H15.4C16.1732 4.8001 16.8 5.4269 16.8 6.2001V13.8001C16.8 14.5733 16.1732 15.2001 15.4 15.2001H4.6C3.8268 15.2001 3.2 14.5733 3.2 13.8001V6.2001Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-ratio-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-ratio", "wpp-icon-ratio-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-ratio-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-ratio-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconRatio$1);
      }
      break;
  } });
}

const WppIconRatio = WppIconRatio$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconRatio, defineCustomElement };
